import Swiper from 'swiper';

const clientGrid = document.querySelector('.client-grid');
let clientItems;
let loop;
let currentIndex = 0;
let mySwiper;
let quote;
let quoteBody;
let quoteAuthor;

function setClient() {
  const currentItem = clientItems[currentIndex];
  clientItems.forEach((client) => {
    client.classList.remove('active');
  });

  currentItem.classList.add('active');
  mySwiper.slideTo(currentIndex);

  quote.classList.add('fade');
  quote.addEventListener('transitionend', () => {
    quoteBody.innerHTML = currentItem.dataset.quote;
    quoteAuthor.innerHTML = currentItem.dataset.author;
    quote.classList.remove('fade');
  });
}

if (document.querySelectorAll('.swiper-container-id-clients').length !== 0) {
  mySwiper = new Swiper('.swiper-container-id-clients', {
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    autoHeight: true,
  });

  mySwiper.on('touchStart', () => {
    clearInterval(loop);
  });

  mySwiper.on('slideChangeStart', () => {
    quote.classList.add('fade');
    currentIndex = mySwiper.activeIndex;
    setClient();
  });

  mySwiper.on('slideChangeEnd', () => {
    quote.classList.remove('fade');
  });
}

if (clientGrid !== null) {
  clientItems = Array.from(clientGrid.querySelectorAll('.client-item'));
  quote = document.getElementById('quote');
  quoteBody = document.getElementById('quoteBody');
  quoteAuthor = document.getElementById('quoteAuthor');

  clientItems.forEach((client) => {
    client.addEventListener('click', function () {
      currentIndex = clientItems.indexOf(this);

      clearInterval(loop);
      setClient();
    });
  });

  // set first grid item
  setClient();
  loop = setInterval(() => {
    if (currentIndex < (clientItems.length - 1)) {
      currentIndex += 1;
    } else {
      currentIndex = 0;
    }
    setClient();
  }, 8000);
}




// WEBPACK FOOTER //
// ./scripts/clients.js